import React, { useEffect, useState } from 'react';
import { FrownOutlined, SmileOutlined } from '@ant-design/icons';
import { Rate } from 'antd';

import * as S from './styles';

interface IRateEmoji {
  onChange: (value: boolean) => void;
}

export type RateEmojiType = 'true' | 'false' | undefined;

const RateEmoji = ({ onChange }: IRateEmoji) => {
  const [value, setValue] = useState<RateEmojiType>();

  useEffect(() => {
    if (value) {
      onChange(value === 'true');
    }
  }, [value, onChange]);

  return (
    <S.RateEmojiContainer value={value}>
      <Rate
        count={1}
        className="rate-emoji rate-emoji-happy"
        onChange={() => setValue('true')}
        character={<SmileOutlined className="rate-emoji-happy-icon" />}
      />
      <Rate
        count={1}
        className="rate-emoji rate-emoji-sad"
        onChange={() => setValue('false')}
        character={<FrownOutlined className="rate-emoji-sad-icon" />}
      />
    </S.RateEmojiContainer>
  );
};

export default RateEmoji;
